import { RestApiResponse } from '../../common/rest-api.response';
import { NomenclaturePosition } from '../nomenclature-position';

export class NomenclaturePositionGetResponse extends RestApiResponse {
    public item: NomenclaturePosition;

    constructor(data?: Partial<NomenclaturePositionGetResponse>) {
        super(data);
        this.item = new NomenclaturePosition(data?.item);
    }
}
